import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WmButtonModule } from '../button/index';
import { StepperComponent } from './stepper.component';
import { StepperContainerComponent } from './stepper-container/stepper-container.component';
import { StepperContentComponent } from './stepper-content/stepper-content.component';
import { StepsDataService } from './stepsData/steps-data.service';
import { WmProgressbarModule } from '../progressbar/index';
import { WmPointModule } from '../point/index';

@NgModule({
	declarations: [StepperComponent, StepperContainerComponent, StepperContentComponent],
	imports: [CommonModule, WmProgressbarModule, WmPointModule, WmButtonModule],
	providers: [StepsDataService],
	exports: [StepperComponent, StepperContainerComponent, StepperContentComponent]
})
export class WmStepperModule {}
